export const SAVE_WISHLIST = 'SAVE_WISHLIST';
export const SAVE_COUNTER_SHOPPINGCART = 'SAVE_COUNTER_SHOPPINGCART';
export const SAVE_QUOTES = 'SAVE_QUOTES';
export const SAVE_ERP = 'SAVE_ERP';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js